import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MainContainer from '../../../components/containers/MainContainer';
import PanelWithClassification from '../../../components/PanelWithClassification';
import {
  fetchTypeMarkTemplates,
  setActiveClassification,
  clearItems,
  fetchDetail,
  CLEAR_TYPE_MARK_TEMPLATES,
} from '@/store/actions/typemarkTemplate';
import TypeMarkTemplateDetailView from './components/TypemarkTemplateDetail';
import TypeMarkModal from '../../project/typemark/components/modals/TypeMarkModal';
import { useMutation, useQueryClient } from 'react-query';
import { SearchContext } from '../../project/building/Building';
import NLeftPanel from '../../../components/NLeftPanel';
import { apiService } from '../../../utils/api';
import { getApiErrorMessage } from '@/utils/apiError';
import { toast } from 'sonner';

function TypeMarkTemplate() {
  const { pagePermission, current_company } = useSelector((state) => state.auth);
  const { contract } = useSelector((state) => state.contract);
  const contractId = contract?.id ?? null;
  const permission = useSelector((state) => state.auth.pagePermission);
  const [visibleBasicEditDialog, setVisibleBasicEditDialog] = useState(false);
  const [search, setSearch] = useState(null);
  const [filter, setFilter] = useState({ is_active: [true] });
  const queryClient = useQueryClient();
  const queryKey = 'instance-type-template';

  const { activeClassification, detail, menuId } = useSelector((state) => state.typeMarkTemplate);

  const dispatch = useDispatch();

  const create = useMutation({
    mutationFn: (values: any) => {
      return apiService.post(`/api/v1/${queryKey}/`, {
        ...values,
        company: current_company,
        classification: activeClassification,
      });
    },
    onSuccess: ({ data }) => {
      queryClient.invalidateQueries(queryKey);
      dispatch(fetchDetail(data.id));
      setVisibleBasicEditDialog(false);
      toast.success('Šablona byla vytvořena');
    },
    onError: (error) => {
      console.error(error);
      toast.error(getApiErrorMessage(error, 'Šablonu se nepodařilo vytvořit'));
    },
  });

  useEffect(() => {
    dispatch(clearItems());
    if (menuId && contractId) {
      queryClient.invalidateQueries(queryKey);
      dispatch({ type: CLEAR_TYPE_MARK_TEMPLATES });
    }
  }, [menuId, contractId]);

  const getDetail = (id) => {
    dispatch(fetchDetail(id));
  };

  const makeActiveClassification = (id) => {
    dispatch(setActiveClassification(id));
    dispatch(fetchTypeMarkTemplates(undefined, undefined, undefined));
  };

  const handleAddTemplate = () => {
    setVisibleBasicEditDialog(true);
  };

  const handleSubmitTypeMarkDialog = ({ values }) => {
    create.mutate(values);
  };

  const onSearch = async (e) => {
    setSearch(e?.target?.value);
  };

  const onFilter = async (value) => {
    setFilter(value);
  };

  return (
    <SearchContext.Provider
      value={{
        search,
        filter,
        setSearch,
        setFilter,
      }}
    >
      <MainContainer>
        <PanelWithClassification
          addItem={() => {}}
          onSearch={() => {}}
          onFilter={() => {}}
          url="left-panel-instance-type-template"
          filteredValues={{
            is_active: [
              { value: true as any, title: 'Aktivní' },
              { value: false as any, title: 'Neaktivní' },
            ],
          }}
          disabledOptionsFlag={true}
          title="Třídník"
          disableAdd
          makeActive={makeActiveClassification}
          active={activeClassification}
          width="340px"
        />
        {activeClassification && (
          <NLeftPanel
            queryKey={queryKey}
            makeActive={getDetail}
            active={detail?.id}
            addItem={() => handleAddTemplate()}
            onSearch={onSearch}
            onFilter={onFilter}
            permission={permission}
            classification={activeClassification}
            title="Sablony Typemarku"
            filteredValues={{
              is_active: [
                { value: true, title: 'Aktivní' },
                { value: false, title: 'Neaktivní' },
              ],
            }}
          />
        )}
        {detail && (
          <TypeMarkTemplateDetailView
            data={detail}
            activeItemId={detail?.id}
            permission={pagePermission}
          />
        )}
        <TypeMarkModal
          title="Vytvořit Šablonu"
          isTemplate
          visible={visibleBasicEditDialog}
          onSubmit={handleSubmitTypeMarkDialog}
          onClose={() => setVisibleBasicEditDialog(false)}
        />
      </MainContainer>
    </SearchContext.Provider>
  );
}

export default TypeMarkTemplate;
